// extracted by mini-css-extract-plugin
export var actions = "QuickBalance-module--actions--9b456";
export var avatar = "QuickBalance-module--avatar--3e789";
export var avatarSkeleton = "QuickBalance-module--avatarSkeleton--d4e4d";
export var balance = "QuickBalance-module--balance--fc540";
export var balanceWithoutPromo = "QuickBalance-module--balanceWithoutPromo--70bf8";
export var btnContainer = "QuickBalance-module--btnContainer--dfba9";
export var caret = "QuickBalance-module--caret--7ab58";
export var container = "QuickBalance-module--container--460c3";
export var divider = "QuickBalance-module--divider--8e83e";
export var header = "QuickBalance-module--header--a536d";
export var iconContainer = "QuickBalance-module--iconContainer--ba175";
export var iconContainerLight = "QuickBalance-module--iconContainerLight--b2cd5";
export var inPlayContainer = "QuickBalance-module--inPlayContainer--ba413";
export var inPlayInner = "QuickBalance-module--inPlayInner--874ba";
export var popoverArrow = "QuickBalance-module--popoverArrow--293cb";
export var popoverContent = "QuickBalance-module--popoverContent--6288f";
export var popoverContentInner = "QuickBalance-module--popoverContentInner--16d1b";
export var promo = "QuickBalance-module--promo--da9cf";
export var text = "QuickBalance-module--text--1c4ee";
export var typography = "QuickBalance-module--typography--f8712";